import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    email: {
        // field
        label: "Эл. почта",
        required: true,
        validators: [requiredField],
        inputProps: { name: "email", type: "email" },
    },
    password: {
        // field
        label: "Пароль",
        required: true,
        validators: [requiredField],
        inputProps: { name: "password" },
    },
    firstName: {
        // field
        label: "Имя",
        required: true,
        validators: [requiredField],
        inputProps: { name: "firstName" },
    },
    lastName: {
        // field
        label: "Фамилия",
        required: true,
        validators: [requiredField],
        inputProps: { name: "lastName" },
    },
    patronymic: {
        // field
        label: "Отчество",
        inputProps: { name: "patronymic" },
    },
    phoneNumber: {
        // field
        label: "Телефон",
        type: "phone",
        required: true,
        validators: [requiredField],
        inputProps: { name: "phoneNumber" },
    },
    phoneNumberExtension: {
        // field
        label: "Добавочный номер",
        inputProps: { name: "phoneNumberExtension" },
    },
    sendLoginData: {
        // field
        label: "Отправить данные для входа на почту пользователя",
        inputProps: { name: "sendLoginData" },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
